
import { BvSubscriber } from './subscriber'

export class BvSubscriberManager {

  static shared = new BvSubscriberManager()

  private subscribers: BvSubscriber[] = []

  add (subscriber: BvSubscriber) {
    this.subscribers.push(subscriber)
  }

  remove (subscriber: BvSubscriber) {
    this.subscribers.splice(this.subscribers.indexOf(subscriber), 1)
  }

  reconnect () {
    this.subscribers.forEach((subscriber) => subscriber.reconnect())
  }

  cleanup () {
    this.subscribers.forEach((subscriber) => subscriber.cleanup())
    this.subscribers = []
  }

  // private start () {
  //   this.subscribers.forEach((subscriber) => subscriber.start())
  // }

  // private stop () {
  //   this.subscribers.forEach((subscriber) => subscriber.stop())
  // }

}
